// eslint-disable-next-line import/no-unresolved
const React = require('realreact'); // from webpack config.resolve.alias
const PropTypes = require('prop-types');

module.exports = React; // We need to export before requiring `create-react-class`
const createClass = require('create-react-class');

// We inject `prop-types` and `createClass` so legacy libraries (react-router@3, relay-classic)
// think they're still there, as they were in React 15
React.PropTypes = PropTypes;
React.createClass = createClass;



// WEBPACK FOOTER //
// ./webpack/react-wrapper.js